var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"rounded-full",class:' ' + _vm.classes,style:(_vm.sectorCSS + "background-color: " + _vm.sectorColor + "; border-color: " + _vm.sectorColor)})])}
var staticRenderFns = []

export { render, staticRenderFns }